import { React, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { base_url } from "../utils/baseUrl";
import { BiArrowBack } from "react-icons/bi";
import { Tabs, Button, Form, Input, Select, Spin } from "antd";

import {
  getBrands,
  createState,
  createCluster,
  getABrand,
  resetState,
} from "../features/statecity/statecitySlice";

const { TabPane } = Tabs;

// let schema = yup.object().shape({
//   title: yup.string().required("Cluster Name is Required"),
// });

const Addstate = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getBrandId = location.pathname.split("/")[3];
  const newBrand = useSelector((state) => state.statecity);
  const {
    isSuccess,
    isError,
    isLoading,
    createdBrand,
    createdcluster,
    updatedBrand,
  } = newBrand;

  useEffect(() => {
    if (getBrandId !== undefined) {
      dispatch(getABrand(getBrandId));
    } else {
      dispatch(resetState());
    }
  }, [getBrandId]);

  useEffect(() => {
    dispatch(getBrands());
  }, []);

  const statelistState = useSelector((state) => state.statecity.brands);

  const [selectedState, setSelectedState] = useState("Select State");
  const [districtOptions, setDistrictOptions] = useState([]);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [districtSearch, setDistrictSearch] = useState(""); // New state for district search input
  const [stateSearch, setStateSearch] = useState(""); // New state for state search input
  const [hiddenInputValue, setHiddenInputValue] = useState("");

  useEffect(() => {
    if (selectedState) {
      fetchDistricts(selectedState);
    }
  }, [selectedState]);

  const handleStateChange = (value) => {
    setSelectedState(value);
    setDistrictOptions([]);
    form.setFieldsValue({ districts: [] }); // Reset districts in the form
    setHiddenInputValue(value);
  };

  const fetchDistricts = async (stateCode) => {
    setLoadingDistricts(true);
    try {
      const response = await fetch(
        `${base_url}common/districtlist/${stateCode}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch districts");
      }
      const data = await response.json();
      setDistrictOptions(data);
    } catch (error) {
      console.error("Error fetching districts:", error);
    } finally {
      setLoadingDistricts(false);
    }
  };

  const handleDistrictSearch = (value) => {
    setDistrictSearch(value);
  };

  const handleStateSearch = (value) => {
    setStateSearch(value);
  };

  const [form] = Form.useForm();

  useEffect(() => {
    if (isSuccess && createdBrand) {
      toast.dismiss();
      toast.success("State Added Successfully!", { autoClose: 10000 });
      form.resetFields();
      navigate("/admin/statecluster");
    }
    if (isSuccess && updatedBrand) {
      toast.dismiss();
      toast.success("State Updated Successfully!");
      form.resetFields();
      navigate("/admin/statecluster");
    }

    if (isError) {
      toast.dismiss();
      toast.error("Something Went Wrong!", { autoClose: 5000 });
      dispatch(resetState());
    }
  }, [isSuccess, isError, isLoading]);

  useEffect(() => {
    if (isSuccess && createdcluster) {
      toast.dismiss();
      toast.success("Cluster Added Successfully!", { autoClose: 10000 });
      form.resetFields();
      navigate("/admin/statecluster");
    }

    if (isError) {
      toast.dismiss();
      toast.error("Something Went Wrong!", { autoClose: 5000 });
    }
  }, [isSuccess, isError, isLoading]);

  const [componentSize, setComponentSize] = useState("default");
  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size);
  };

  const tabData = [
    { label: "Create State - City", key: "1", content: "Create State - City" },
    { label: "Create Cluster", key: "2", content: "Create Cluster" },
  ];

  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key) => {
    setActiveTab(key);
    form.resetFields();
  };

  const onFinish = async (values) => {
    const selectedStateName = statelistState.find(
      (state) => state.code === values.state
    )?.state;
    const selectedDistrictNames = districtOptions
      .filter((district) => values.districts.includes(district.District_Code))
      .map((district) => district.District);

    const mergedValues = {
      ...values,
      code: hiddenInputValue,
      state_name: selectedStateName,
      district_name: selectedDistrictNames,
    };

    try {
      await dispatch(createState(mergedValues)).unwrap();
      toast.success("State City Added Successfully!");
      setTimeout(() => {
        dispatch(resetState);
      }, 300);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.status === "fail"
      ) {
        toast.error("Duplicate Entry Please Choose Other");
      } else {
        toast.error("Something Went Wrong!");
      }
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const onFinish2 = async (values) => {
    const selectedStateName = statelistState.find(
      (state) => state.code === values.state
    )?.state;
    const selectedDistrictNames = districtOptions
      .filter((district) => values.districts.includes(district.District_Code))
      .map((district) => district.District);
    const mergedValues = {
      ...values,
      code: hiddenInputValue,
      state_name: selectedStateName,
      district_name: selectedDistrictNames,
    };

    try {
      await dispatch(createCluster(mergedValues)).unwrap();
      toast.success("Cluster Added Successfully!");
      setTimeout(() => {
        dispatch(resetState);
      }, 300);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.status === "fail"
      ) {
        toast.error("Duplicate Entry Please Choose Other");
      } else {
        toast.error("Something Went Wrong!");
      }
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">
          Creating State-City | Clusters by Selecting by Dropdown
        </h3>
        <button
          className="bg-transparent border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5" /> Go Back
        </button>
      </div>

      <Tabs defaultActiveKey="1" centered onChange={handleTabChange}>
        <TabPane tab="Create State City" key="1">
          {activeTab === "1" && (
            <Form
              {...formItemLayout}
              form={form}
              name="register"
              onFinish={onFinish}
              initialValues={{ prefix: "+91", code: "" }}
              style={{ maxWidth: 600 }}
              scrollToFirstError
            >
              <Form.Item
                label="Select State"
                name="state"
                rules={[{ required: true, message: "Please Select Once!" }]}
              >
                <Select
                  placeholder="Select State"
                  onChange={handleStateChange}
                  value={selectedState}
                  showSearch
                  onSearch={handleStateSearch}
                  filterOption={false}
                >
                  {statelistState
                    .filter((state) =>
                      state.state
                        .toLowerCase()
                        .includes(stateSearch.toLowerCase())
                    )
                    .map((i, j) => (
                      <Select.Option key={j} value={i.code}>
                        {i.state}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <input type="hidden" name="code" value={hiddenInputValue} />

              <Form.Item
                label="Select District"
                name="districts"
                rules={[{ required: true, message: "Please Select Once!" }]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select District"
                  disabled={!selectedState}
                  showSearch
                  onSearch={handleDistrictSearch}
                  filterOption={false}
                  notFoundContent={
                    loadingDistricts ? <Spin size="small" /> : null
                  }
                >
                  {districtOptions
                    .filter((district) =>
                      district.District.toLowerCase().includes(
                        districtSearch.toLowerCase()
                      )
                    )
                    .map((district, index) => (
                      <Select.Option key={index} value={district.District_Code}>
                        {district.District}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item style={{ textAlign: "right" }}>
                <Button type="primary" htmlType="submit">
                  Create
                </Button>
              </Form.Item>
            </Form>
          )}
        </TabPane>

        <TabPane tab="Create Cluster" key="2">
          {activeTab === "2" && (
            <Form
              {...formItemLayout}
              form={form}
              name="register"
              onFinish={onFinish2}
              initialValues={{ prefix: "+91", code: "" }}
              style={{ maxWidth: 600 }}
              scrollToFirstError
            >
              <Form.Item
                label="Cluster Name"
                name="name"
                rules={[
                  { required: true, message: "Please Enter Cluster Name!" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Select State"
                name="state"
                rules={[{ required: true, message: "Please Select Once!" }]}
              >
                <Select
                  placeholder="Select State"
                  onChange={handleStateChange}
                  value={selectedState}
                  showSearch
                  onSearch={handleStateSearch}
                  filterOption={false}
                >
                  {statelistState
                    .filter((state) =>
                      state.state
                        .toLowerCase()
                        .includes(stateSearch.toLowerCase())
                    )
                    .map((i, j) => (
                      <Select.Option key={j} value={i.code}>
                        {i.state}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <input type="hidden" name="code" value={hiddenInputValue} />

              <Form.Item
                label="Select District"
                name="districts"
                rules={[{ required: true, message: "Please Select Once!" }]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select District"
                  disabled={!selectedState}
                  showSearch
                  onSearch={handleDistrictSearch}
                  filterOption={false}
                  notFoundContent={
                    loadingDistricts ? <Spin size="small" /> : null
                  }
                >
                  {districtOptions
                    .filter((district) =>
                      district.District.toLowerCase().includes(
                        districtSearch.toLowerCase()
                      )
                    )
                    .map((district, index) => (
                      <Select.Option key={index} value={district.District_Code}>
                        {district.District}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item style={{ textAlign: "right" }}>
                <Button type="primary" htmlType="submit">
                  Create
                </Button>
              </Form.Item>
            </Form>
          )}
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Addstate;
